export default __webpack_public_path__ + "static/media/fifa1-cn.8e4af27f.gif";